<!-- 系统管理-角色管理 -->
<template>
  <div class="md-layout">
    <!-- 卡片 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <add-button @click="table_addItem">{{$I18n("add_role")}}</add-button>
          <!-- 表格 { 点击后可展示对应的子菜单 }
            角色 ID
            角色名称
            角色状态 {1: 打开, 2:禁止}
            创建时间
            操作 [修改角色, 删除角色]
           -->
          <md-table v-model="table_Data">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="$I18n('role_id')" class="numbers">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('role_name')">
                {{ $I18n("lang_i18n") === "zh" ? item.cn_name : item.name }}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('role_state')">{{ $I18n($Param.roleState.getName(item.state)) }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="table_editItem(item)" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modal_title"
      :right = "modal_type!=='delete'"
      @submit= "modal_form_submit"
      @close = "closeModal"
    >
      <!-- 弹窗-主题 -->
      <template slot="body">
        <!-- 弹窗-删除弹窗 -->
        <div v-if="modal_type==='delete'">{{
          $I18n("check_delete", $I18n("lang_i18n") === "zh" ? modalData.Form.cn_name : modalData.Form.name)
        }}</div>
        <!-- 弹窗-修改/添加弹窗表单 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <!-- 表单-选择表格-菜单表格(该角色可浏览的菜单) {多选}
            菜单ID
            菜单中文名字
            [是否选择该菜单]
           -->
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label"> {{$I18n("list_setting")}}: </label>
          </div>
          <div class="md-layout">
            <div class="md-layout-item">
              <md-table v-model="modal_form_table_menuData" md-card class="table-selected">
                <md-table-row @click="modal_form_table_clickRowMenu(item.menu_id)" slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell :md-label="$I18n('menu_id')">  {{ item.menu_id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('menu_name')">
                    {{ $I18n("lang_i18n") === "zh" ? item.menu_cn_name : item.menu_name }}
                  </md-table-cell>
                  <md-table-cell class="table-checkbox"> 
                    <md-icon class="checkbox-color">{{selected_menuData.includes(item.menu_id) ?"done" :"" }}</md-icon>
                  </md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
              </md-table>
            </div>
          </div>
          <!-- 表单-选择表格-角色菜单(该角色可浏览的角色) {多选}
            角色ID
            角色名字
            [是否选择该菜单]
           -->
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label"> {{$I18n("role_setting")}}: </label>
          </div>
          <div class="md-layout">
            <div class="md-layout-item">
              <md-table v-model="table_rowData" md-card class="table-selected">
                <md-table-row @click="modal_form_table_clickRowRole(item.id)" slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell :md-label="'ID'">  {{ item.id }}</md-table-cell>
                  <md-table-cell :md-label="$I18n('name')">
                    {{ $I18n("lang_i18n") === "zh" ? item.cn_name : item.name }}
                  </md-table-cell>
                  <md-table-cell class="table-checkbox"> 
                    <md-icon class="checkbox-color">{{selected_roleData.includes(item.id) ?"done" :"" }}</md-icon>
                  </md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
              </md-table>
            </div>
          </div>
        </div>
      </template>
    </simple-modal >
  </div>
</template>
<script>
import { timestampToString1000, FormClass } from "@/common/tools.js";

export default {
  data() {
    return {
      icon : "person",                   // 主体-卡片-ICON
      title : this.$I18n("role_manage"), // 主体-卡片-标题
      table_rowData : [],                // 主体-表格-原始数据
      currentPage : 1,                   // 主体-表格-所处页面
      total : 0,                         // 主体-表格-数据总数
      pageSize : 10,                     // 通用-表格每页数据数量

      selected_menuData : [],            // 弹窗-表单-已选择的菜单列表
      selected_roleData : [],            // 弹窗-表单-已选择的角色列表

      modal_type : "add",                // 弹窗-打开类型 ["add", "edit", "delete"]
      modal_title : "",                  // 弹窗-弹窗标题

      menuData : [],                     // 通用-完整菜单数据
      modalData : new FormClass({        // 弹窗-表单参数
        id     : {
          init : "",
          check: "int",
        },
        name   : {
          init : "",
          check: "required",
        },
        cn_name: {
          init : "",
          check: "required",
        },
        state  : 1,
        menus  : [],
        remark : "",
      }),
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  methods: {
    closeModal(){
      this.api_getPageData();
      this.modalData.Reset()
    },
    api_getPageData(){                  // API-获取页面信息
      // 获取角色
      this.$api.getRole({ // api: /user/role/query
          type:0,
      })
        .then(this.$Then(res => {
          this.table_rowData = res.data.map(item => {
            return {
              ...item,
              state: item.state ?item.state :0,
            };
          })
          this.total = res.data.length;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.table_rowData = [];
          this.total = 0;
        }))
      //获取菜单
      this.$api.getMenu({ // api: /user/menu/query
        type : this.UserInfo.role_id != 1 ? 1 : 0,
      })
        .then(this.$Then(res => {
          this.menuData = res.data;
        }))
        .catch(this.$Catch("",() => {
          this.menuData = [];
        }))
    },
    modal_form_table_clickRowRole(id) { // 弹窗-表单-表格-选择一个角色
      if(this.selected_roleData.includes(id)){
        this.selected_roleData = this.selected_roleData.filter(item => {
          return item !== id;
        });
      } else {
        this.selected_roleData.push (id)
      }
    },
    modal_form_table_clickRowMenu(id) { // 弹窗-表单-表格-选择一个菜单
      if(this.selected_menuData.includes(id)){
        this.selected_menuData = this.selected_menuData.filter(item => {
          return item !== id;
        });
      } else {
        this.selected_menuData.push (id)
      }
    },
    modal_closeModal () {               // 弹窗-关闭弹窗
      this.$refs.modal.close()
    },
    table_addItem (){                   // 表格-打开 新增角色 弹窗
      this.modal_title = this.$I18n("add_role");
      this.modal_type  = "add";
      this.$refs.modal.open()

      this.modalData.Reset();
      this.selected_menuData = [];
      this.selected_roleData = [];
    },
    table_editItem (item){              // 表格-打开 修改角色 弹窗
      this.modal_title = this.$I18n("edit_role");
      this.modal_type = "edit";
      this.$refs.modal.open()


      this.$api.getRoleDetail({ // api : /user/role/info
        id : item.id,
      })
        .then(this.$Then(res => {
          this.modalData.Update(res.data);

          this.selected_menuData = res.data.menu_ids ?[...res.data.menu_ids] :[];
          this.selected_menuData = this.selected_menuData.filter(item => {
            return !this.menuData.some(menu => menu.menu_id == item)
          })
          this.selected_roleData = res.data.role_ids ?[...res.data.role_ids] :[];
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    table_deleteItem (item){             // 表格-打开 删除角色 弹窗
      this.modal_title = this.$I18n("del_role");
      this.modal_type  = "delete";
      this.$refs.modal.open()

      this.modalData.Update(item);
    },
    modal_form_submit () {              // 弹窗-表单-提交表单
      if(this.modal_type === "delete"){
        this.$api.delRole(this.modalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("delete_success"));
            this.modal_closeModal();
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      } else if (this.modal_type === "add") {
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.addRole({ // api: /user/role/add
          ...this.modalData.Form,
          role_ids : this.selected_roleData.map(item => parseInt(item)),
          menu_ids : this.selectedMenus,
        })
          .then(this.$Then(() => {
              this.$successMsg(this.$I18n("add_success"));
              this.modal_closeModal();
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.modal_type === "edit"){
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        this.$api.editRole({ // api: /user/role/modify
          ...this.modalData.Form,
          role_ids : this.selected_roleData.map(item => {
            return parseInt(item)
          }),
          menu_ids : this.selectedMenus,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.modal_closeModal();
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
  computed: {
    table_Data(){     // 表格数据
      if (!this.table_rowData || this.table_rowData.length === 0){
        return [];
      } else {
        return [...this.table_rowData]
          .splice((this.currentPage-1) * this.pageSize, this.pageSize)
          .map(item => {
            // 角色状态 [1: 开启, 2: 禁用]
            return {
              create_time: timestampToString1000(item.gmt_create),
              ... item,
            }
          })
      }
    },
    modal_form_table_menuData(){ // 弹窗里的菜单表格数据 将 主菜单和子菜单进行拼合
      let res = [];
      this.menuData.forEach(item => {
        if (item.sub_menus && item.sub_menus.length > 0){
          res = [...res, ...item.sub_menus.map(sub => {
            return {
              par_menu_id : parseInt(item.menu_id),
              ...sub,
            }
          })]
        }
      })
      return res;
    },
    selectedMenus() { // 选中的 菜单的数组 (包含 父节点id) 用于API请求
      let res = this.selected_menuData.map(item => {
        return parseInt(item);
      });
      this.modal_form_table_menuData.forEach(item => {
        if(res.includes(parseInt(item.menu_id)) && !res.includes(item.par_menu_id)){
          res.push(item.par_menu_id);
        }
      });
      return res;
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("role_id"),
          keys    : "id",
          type    : "input",
          placeholder: this.$I18n('pls_input_role_id'),
          required: true,
          check   : true,
        },{
          label   : this.$I18n("role_name"),
          keys    : "name",
          type    : "input",
          placeholder: this.$I18n('pls_input_role_name'),
          required: true,
          check   : true,
        },{
          label   : this.$I18n("menu_cn_name"),
          keys    : "cn_name",
          type    : "input",
          placeholder: this.$I18n('pls_input_role_name'),
          required: true,
          check   : true,
        },{
          label   : this.$I18n("role_state"),
          keys    : "state",
          type    : "select",
          options : this.$Param.roleState.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          placeholder: this.$I18n('pls_input_role_name'),
          required: true,
          check   : true,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>